import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const softwarePlanSettingsFeaturesRoute: InvariantJiraRoute = {
	name: 'plan-settings-features',
	path: '/jira/plans/:planId/scenarios/:scenarioId/settings/features',
};
